import { IAppState } from "../../../../lib/types/AppState"

export const marketplaceMatchesSlideoutSelector = (state: IAppState) => ({
  session: state.session,
  slideout: state.marketPricing.MarketplaceMatchesReducer.marketplaceMatchesReducer.slideout
})

export const marketplaceMatchesSelector = ({ session, marketPricing, slideout: mainSlideout }: IAppState) => {
  const { displayIn } = marketPricing.MarketPricingReducer
  const { matches, slideout } = marketPricing.MarketplaceMatchesReducer.marketplaceMatchesReducer
  const grid = marketPricing.MarketplaceMatchesReducer.marketplaceMatchesGridReducer
  const { selectedViewPk } = marketPricing.JobPricingReducer.MainJobPricingReducer
  const slideoutOpen = mainSlideout.open

  return { session, displayIn, matches, selectedViewPk, grid, slideout, slideoutOpen }
}

export const marketplaceMatchesGridSelector = ({ session, marketPricing, slideout: globalSlideout }: IAppState) => {
  const { displayIn, loadingId, isMatchDeleting } = marketPricing.MarketPricingReducer
  const { matches, slideout, settings } = marketPricing.MarketplaceMatchesReducer.marketplaceMatchesReducer
  const grid = marketPricing.MarketplaceMatchesReducer.marketplaceMatchesGridReducer
  const { selectedCutIDs, selectedViewPk } = marketPricing.JobPricingReducer.MainJobPricingReducer
  const jobGridLoading = marketPricing.JobPricingReducer.JobPricingGridReducer.loading
  const slideoutOpen = globalSlideout.open

  return { session, displayIn, matches, selectedCutIDs, selectedViewPk, grid, loadingId, isMatchDeleting, slideout, settings, jobGridLoading, slideoutOpen }
}
